module.exports = __webpack_public_path__ + "static/media/  (154).af99d7c9.jpg";